import styled from 'styled-components/macro'
import { EroDarkEastSVG } from 'src/components/Icons/Brand'
import { StandardButton } from 'src/components/Reusable/Buttons'

export const CheckWithEroIcon = styled(EroDarkEastSVG)<{
  $isDisabled?: boolean
  height?: string
  width?: string
}>`
  height: ${({ height }) => (height ? `${height}` : '1.7em')};
  width: ${({ width }) => (width ? `${width}` : '1.7em')};
  path {
    opacity: ${({ $isDisabled }) => ($isDisabled ? '0.5' : '1')};
  }
`

export const CheckWithEroButtonContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5em;
  height: 100%;
  width: 100%;
  padding: 0 1em;
`

export const CheckWithEroStyledButton = styled(StandardButton)`
  height: 40px;
  padding: 0;
`
